export enum SYNC_ACTIONS {
  SYNC_APPLICATION_ACTION = 'syncApplication',
  SYNC_APPLICATION_STATUS_ACTION = 'syncApplicationStatus',
  SYNC_CUSTOMER_ACTION = 'syncCustomer',
  SYNC_DECLINE_CREDIT_REPAIR_REFERRAL_ACTIVITY = 'syncDeclineCreditRepairReferralActivity',
  SYNC_DECLINE_DEBT_BUSTERS_REFERRAL_ACTIVITY = 'syncDeclineDebtBustersReferralActivity',
  SYNC_CUSTOMER_CONSENT_ACTION = 'syncCustomerConsent',
  SYNC_APPLICATION_DOCUMENTS_ACTION = 'syncApplicationDocuments',
}

export enum CHANGED_EVENTS {
  CUSTOMER_CHANGED = 'customerChanged',
  APPLICATION_CHANGED = 'applicationChanged',
  APPLICATION_STATUS_CHANGED = 'applicationStatusChanged',
  DECLINE_CREDIT_REPAIR_REFERRAL_ACTIVITY = 'declineCreditRepairReferralActivity',
  DECLINE_DEBT_BUSTERS_REFERRAL_ACTIVITY = 'declineDebtBustersReferralActivity',
  CUSTOMER_CONSENT_CHANGED = 'customerConsentChanged',
  APPLICATION_DOCUMENTS_CHANGED = 'applicationDocumentsChanged',
}

export enum CONTACT_TAGS {
  DECLINED_CREDIT_REPAIR_ELIGIBLE = 59,
  CREDIT_REPAIR_OPT_IN = 88,
  DECLINED_DEBT_BUSTERS_ELIGIBLE = 89,
  DEBT_BUSTERS_OPT_IN = 90,
}

export enum CONTACT_TAGS_DESCRIPTION {
  DECLINED_CREDIT_REPAIR_ELIGIBLE = 'Decline credit repair eligible',
  CREDIT_REPAIR_OPT_IN = 'Credit repair opt in',
  DECLINED_DEBT_BUSTERS_ELIGIBLE = 'Decline debt busters eligible',
  DEBT_BUSTERS_OPT_IN = 'Debt busters opt in',
}
